import { connect } from "react-redux";
import ViewPocs from "./pocList";
import { bindActionCreators } from "redux";
import { getCorpPocList } from "services/redux/brandActivtion/corporateClient/action";

const mapStateToProps = (state) => ({
    corpClientPoc: state.CorpClientReducer.corpClientPoc,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getCorpPocList
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ViewPocs);
